export default __webpack_public_path__ + "static/media/bg_calendar.a28f6912.png";